import { useEffect, useMemo, useState } from "react";
import api from "../../../services/api";
import { buildRoleSelectOptions } from "../../../utils/roleSelectOptions";

export default function usePolicyCompanyRoles() {
  const [companyRoles, setCompanyRoles] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await api.get("/global-settings/roles");
        if (!cancelled && response.data?.success) {
          setCompanyRoles(response.data.data || []);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Error fetching roles for policy wizard:", error);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const policyRoleOptions = useMemo(() => buildRoleSelectOptions(companyRoles), [companyRoles]);
  const defaultPolicyRoleValue = policyRoleOptions[0]?.value || "";

  return { companyRoles, policyRoleOptions, defaultPolicyRoleValue };
}
